module.exports = "/fonts/fa-regular-400.eot?859001f6ae8eb0bb3878aaa971b50fc6";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/styles/fontawesome/webfonts/fa-regular-400.eot
// module id = 6/X3
// module chunks = 0 1